<h4 class="title">Configurable Screen Map</h4>


<!-- <div class="row">
    <div class="col-md-5">
        <h5 class="form-lable">Level:</h5>
        <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Screen:</h5>
        <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" style="margin-top: 25px;">Search</button>
    </div>
</div>
-->
<br> 
<div class="row">
    <!-- <div class="col-md-4">
            <div class="search-hero">
                <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                    [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
            </div>
        </div> -->
    <div class="col-md-6">
        <h5 class="form-lable">Screen ng-template: <span>CONTACT RECORDING-LOAN</span></h5>

    </div>
    <div class="col-md-6">
        <h5 class="form-lable" style="text-align: right;">Screen Type:<span>LOANS</span></h5>

    </div>
    <div class="col-md-12">
        <div class="doc-table">
            <table class="det-t">
                <tr class="thhead th-b">
                    <th class="th-1">
                        Fields
                    </th>
                    <th class="th-1">
                        <input type="checkbox">
                    </th>
                </tr>
                <tr class="thhead th-b">
                    <th colspan="2" class="th-1" style="text-align: center;">
                     BLOCK
                    </th>
                </tr>
                <tr class="tdrow">
                    <td>Customer Information</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Extra Fields</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Contact Information</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Loan Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Allocation Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Delinquency Flow</td>
                    <td><input type="checkbox"></td>
                </tr>
    
                <tr class="tdrow">
                    <td>Account Summary</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Overdue Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Case Marking</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Enable Auto PopUp</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="thhead th-b">
                    <th colspan="2" class="th-1" style="text-align: center;">
                     BUTTON
                    </th>
                </tr>
                <tr class="tdrow">
                    <td>Customer Information</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Co-applicant</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Guarantor/Reference Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Asset Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Collateral Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Payments</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Statcard</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Repayment Schedule</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Bounces</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Statement</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Foreclosure</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Follow Up Trails</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>FYI & OLd Follow Up Trails</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Allocation History Report</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Legal Case Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Security Cheque Details</td>
                    <td><input type="checkbox"></td>
                </tr>
                <tr class="tdrow">
                    <td>Settlement Details</td>
                    <td><input type="checkbox"></td>
                </tr>
            </table>
        </div>
    </div>
    <br>
</div>


<!-- <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
      <tr style="text-align: center;">
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Address Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Bank Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Income Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Liability Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Esisting Asset Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Credit Card Details</button> </td>
      </tr>
          </ng-template>
       </p-table>  </div>
    </div> -->